document.addEventListener('DOMContentLoaded', function () {

  /* call us popup */

  const popup = document.getElementById('consultation-popup');

  if (popup) {
    let links = document.querySelectorAll('.menu-list__link[href="#"]');
    links.forEach(link => {
      link.classList.add('consultation-link');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        popup.classList.add('active');
      });
    });

    const closeBtn = popup.querySelector('.close');
    if (closeBtn) closeBtn.addEventListener('click', () => popup.classList.remove('active'));

    popup.addEventListener('click', e => {
      if (e.target === popup) popup.classList.remove('active');
    });
  }

});

/* ==========================
        DOWNLOAD POPUP OPEN/CLOSE
     ========================== */
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('pdf-popup');
  const buttons = document.querySelectorAll('.tlir-button[data-pdf]');

  buttons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      // Підставляємо текст з metaobject
      document.getElementById('popup-heading').textContent = btn.dataset.heading;
      document.getElementById('popup-text').textContent = btn.dataset.text;

      // Зберігаємо PDF
      popup.dataset.pdf = btn.dataset.pdf;

      popup.classList.add('active');
    });
  });

  const closeBtn = popup.querySelector('.close');
  if (closeBtn) closeBtn.addEventListener('click', () => popup.classList.remove('active'));
  popup.addEventListener('click', e => { if (e.target === popup) popup.classList.remove('active'); });

  // =============================
  // FORM VALIDATION + PDF DOWNLOAD
  // =============================
  const form = popup.querySelector('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      let isValid = true;
      form.querySelectorAll('.error-tooltip').forEach(msg => msg.remove());

      form.querySelectorAll('input.validate').forEach(field => {
        let errorMessage = '';
        if (!field.value.trim()) errorMessage = 'Required field';
        else if (field.type === 'email' && !/^\S+@\S+\.\S+$/.test(field.value)) errorMessage = 'Invalid email';
        else if (field.type === 'tel' && !/^\+\d[\d\s\-]+$/.test(field.value)) errorMessage = 'Invalid phone';

        if (errorMessage) {
          isValid = false;
          showTooltip(field, errorMessage);
        }
      });

      if (!isValid) e.preventDefault();
      else {
        e.preventDefault(); // блок звичайного сабміту
        popup.classList.remove('active');

        // Завантаження PDF
        const pdfUrl = popup.dataset.pdf;
        if (pdfUrl) {
          const a = document.createElement('a');
          a.href = pdfUrl;
          a.download = '';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  }

  function showTooltip(field, message) {
    const tooltip = document.createElement('div');
    tooltip.className = 'error-tooltip';
    tooltip.textContent = message;
    tooltip.style.position = 'absolute';
    tooltip.style.background = 'rgba(255,0,0,0.9)';
    tooltip.style.color = '#fff';
    tooltip.style.padding = '4px 8px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.fontSize = '0.8em';
    tooltip.style.zIndex = 9999;
    tooltip.style.whiteSpace = 'nowrap';

    const parent = field.parentElement;
    if (window.getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    tooltip.style.top = (field.offsetTop - tooltip.offsetHeight - 6) + 'px';
    tooltip.style.left = field.offsetLeft + 'px';

    parent.appendChild(tooltip);
    field.addEventListener('focus', () => tooltip.remove(), { once: true });
  }
});

/* zoho popup */
(function () {
  function initZohoPopup() {
    // Створюємо popup один раз
    if (!document.getElementById("formsLightBox_533623")) {
      constructZohoPopup();
    }

    // Старі Zoho кнопки
    document.querySelectorAll(".zf_button").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        openZohoPopup(window.downloadBrochureLink);
      });
    });

    // Нові кнопки з popup_link
    document.querySelectorAll(".zf-button.popup-button").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        openZohoPopup(btn.dataset.popupLink);
      });
    });

    // Rich content buttons з popup_link
document.querySelectorAll(".rich-content-text .popup-button").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    openZohoPopup(btn.dataset.popupLink);
  });
});

// TLIR buttons з popup_link
document.querySelectorAll(".tlir-popup-button").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const popupLink = btn.dataset.tlirPopupLink;

    if (popupLink) {
      openZohoPopup(popupLink);
    }
  });
});

// TRIL buttons з власним popup link
document.querySelectorAll(".tril-popup-button").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const popupLink = btn.dataset.trilPopupLink;

    if (popupLink) {
      openZohoPopup(popupLink);
    }
  });
});

// TTIB buttons з власним popup link
document.querySelectorAll(".ttib-popup-button").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const popupLink = btn.dataset.ttibPopupLink;

    if (popupLink) {
      openZohoPopup(popupLink);
    }
  });
});

// TBIT buttons з власним popup link
document.querySelectorAll(".tbit-popup-button").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const popupLink = btn.dataset.tbitPopupLink;

    if (popupLink) {
      openZohoPopup(popupLink);
    }
  });
});

// Banner button 2 з власним popup link
document.querySelectorAll(".banner-button-2-popup").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const popupLink = btn.dataset.bannerButton2PopupLink;

    if (popupLink) {
      openZohoPopup(popupLink);
    }
  });
});

// Short info
document.querySelectorAll(".short-info-popup-button").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const popupLink = btn.dataset.popupLink;

    if (popupLink) {
      openZohoPopup(popupLink);
    }
  });
});



  // Book consultation popup
  document.querySelectorAll(".book-consultation").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const popupLink = btn.dataset.popupLink;

      if (popupLink) {
        openZohoPopup(popupLink);
      }
    });
  });

  }

  function constructZohoPopup() {
    var iframeDiv = document.createElement("div");
    iframeDiv.id =
      "QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4_533623";
    iframeDiv.className = "zf_main_id_533623";

    var closeFormDiv = document.createElement("div");
    closeFormDiv.id = "deleteform_533623";
    closeFormDiv.className = "zf_lb_closeform_533623";
    closeFormDiv.tabIndex = 0;

    var containerDiv = document.createElement("div");
    containerDiv.id = "containerDiv_533623";
    containerDiv.className = "zf_lB_Container_533623";

    containerDiv.appendChild(iframeDiv);
    containerDiv.appendChild(closeFormDiv);

    var wrapperDiv = document.createElement("div");
    wrapperDiv.className = "zf_lB_Wrapper_533623";
    wrapperDiv.appendChild(containerDiv);

    var dimmerDiv = document.createElement("div");
    dimmerDiv.className = "zf_lB_Dimmer_533623";
    dimmerDiv.addEventListener("click", closeZohoPopup);

    var mainDiv = document.createElement("div");
    mainDiv.id = "formsLightBox_533623";
    mainDiv.style.display = "none";

    mainDiv.appendChild(wrapperDiv);
    mainDiv.appendChild(dimmerDiv);

    document.body.appendChild(mainDiv);

    // Кнопка закриття
    closeFormDiv.addEventListener("click", closeZohoPopup);

    closeFormDiv.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        closeZohoPopup();
      }
    });
  }

  function openZohoPopup(url) {
    if (!url) return;

    var container = document.getElementById(
      "QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4_533623"
    );

    var popup = document.getElementById("formsLightBox_533623");

    if (!container || !popup) return;

    // Якщо iframe вже є — оновлюємо його URL
    var iframe = container.querySelector("iframe");

    if (iframe) {
      iframe.src = url;
    } else {
      iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.style.border = "none";
      iframe.style.width = "100%";
      iframe.style.minHeight = "500px";

      container.appendChild(iframe);
    }

    popup.style.display = "block";
    document.body.style.overflow = "hidden";
  }

  function closeZohoPopup() {
    var popup = document.getElementById("formsLightBox_533623");

    if (popup) {
      popup.style.display = "none";
    }

    document.body.style.overflow = "";
  }

  // Чекаємо завантаження сторінки
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZohoPopup);
  } else {
    initZohoPopup();
  }
})();

/* change slides on click */
document.querySelectorAll('[data-slides]').forEach(slider => {
  const track = slider.querySelector('.slider-track');
  const slides = Array.from(track.children);
  const wrapper = slider.closest('.slider-wrapper');
  const nextBtn = wrapper.querySelector('[data-next]');
  const prevBtn = wrapper.querySelector('[data-prev]');
  let index = 0;

  function updateSlide() {
    track.style.transform = `translateX(-${index * 100}%)`;
  }
  nextBtn.addEventListener('click', () => {
    index = (index + 1) % slides.length;
    updateSlide();
  });
  prevBtn.addEventListener('click', () => {
    index = (index - 1 + slides.length) % slides.length;
    updateSlide();
  });
});

document.querySelectorAll('.tlir-button[data-button-type]').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    const type = btn.dataset.buttonType;

    if (type === 'advice') {
      document.querySelector('#popup-advice').classList.add('active');
    } else if (type === 'virtual_demo') {
      document.querySelector('#popup-virtual-demo').classList.add('active');
    }
  });
});

/* Review Text overflow */
  function handleReviewOverflow() {
    document.querySelectorAll('.review-text').forEach(el => {
      el.style.overflowY = 'visible';
      el.style.maxHeight = 'none';

      if (el.scrollHeight > 210) {
        el.style.maxHeight = '210px';
        el.style.overflowY = 'auto';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', handleReviewOverflow);
  window.addEventListener('resize', handleReviewOverflow);

/* FAQ */
document.addEventListener('DOMContentLoaded', () => {

  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    question.addEventListener('click', () => {
      const isOpen = question.classList.contains('active');

      if (!isOpen) {
        question.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        question.classList.remove('active');
        answer.style.maxHeight = null;
      }
    });
  });

});

/* blocks fade in */
document.addEventListener('DOMContentLoaded', function () {
  const animateElements = document.querySelectorAll('.animate');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // щоб не запускати повторно
      }
    });
  }, { threshold: 0.2 });

  animateElements.forEach(el => observer.observe(el));
});

/* divider */
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.blog-details-wrapper');
  if (!wrapper) return;

  const blocks = wrapper.querySelectorAll('[id]');

  blocks.forEach(block => {
    const id = block.id.trim();
    const num = Number(id);

    if (!Number.isInteger(num) || num < 0 || num > 20) return;

    //  rich-content-block
    if (block.classList.contains('rich-content-block')) {
      const heading = block.querySelector('.like-h2');
      if (heading) {
        const hr = document.createElement('hr');
        hr.className = 'blog-divider';
        heading.before(hr);
      }
    }

    // text-left-image-right
    if (block.classList.contains('text-left-image-right')) {
      const hr = document.createElement('hr');
      hr.className = 'blog-divider';
      block.before(hr);
    }

    // before-after
    if (block.classList.contains('before-after-wrapper')) {
      const heading = block.querySelector('h2');
      if (heading) {
        const hr = document.createElement('hr');
        hr.className = 'blog-divider';
        heading.before(hr);
      }
    }

    // faq
    if (block.classList.contains('faq-section-wrapper')) {
      const heading = block.querySelector('like-h2');
      if (heading) {
        const hr = document.createElement('hr');
        hr.className = 'blog-divider';
        heading.before(hr);
      }
    }
  });
});

/* blog posts button */
document.querySelectorAll('.metafield-rich_text_field p').forEach(p => {

  // Видаляємо пробіли з прямого тексту
  const directText = Array.from(p.childNodes)
    .filter(node => node.nodeType === Node.TEXT_NODE)
    .map(n => n.textContent.trim())
    .join('');

  // Беремо всі дочірні елементи, окрім <a>
  const otherChildren = Array.from(p.children)
    .filter(el => el.tagName.toLowerCase() !== 'a');

  // Беремо всі <a> серед дочірніх
  const links = Array.from(p.children)
    .filter(el => el.tagName.toLowerCase() === 'a');

  // Текст порожній і тільки один <a>, без інших дочірніх елементів
  if (directText === '' && links.length === 1 && otherChildren.length === 0) {

    const a = links[0];

    // Знаходимо найближчий rich-content блок
    const richContentBlock = p.closest(
      '[data-button-bg], [data-button-color], [data-popup-link], [data-button-width], [data-button-width-mobile]'
    );

    const buttonBackground = richContentBlock?.getAttribute('data-button-bg');
    const buttonColor = richContentBlock?.getAttribute('data-button-color');
    const popupLink = richContentBlock?.getAttribute('data-popup-link');
    const gradient1 = richContentBlock?.getAttribute('data-button-gradient-1');
    const gradient2 = richContentBlock?.getAttribute('data-button-gradient-2');
    const gradient3 = richContentBlock?.getAttribute('data-button-gradient-3');
    const buttonWidth = richContentBlock?.getAttribute('data-button-width');
    const buttonWidthMobile = richContentBlock?.getAttribute('data-button-width-mobile');

    // Стандартні стилі
    a.style.display = 'table';
    a.style.margin = '15px auto';
    a.style.padding = '15px 30px';
    a.style.textDecoration = 'none';
    a.style.borderRadius = '10px';
    a.style.transition = '.3s ease-in-out';

// Ширина кнопки
function setButtonWidth() {
  if (window.innerWidth <= 768) {

    if (buttonWidthMobile) {
      a.style.setProperty(
        'width',
        buttonWidthMobile,
        'important'
      );
    } else if (buttonWidth) {
      a.style.setProperty(
        'width',
        buttonWidth,
        'important'
      );
    }

  } else {

    if (buttonWidth) {
      a.style.setProperty(
        'width',
        buttonWidth,
        'important'
      );
    } else {
      a.style.removeProperty('width');
    }

  }
}

setButtonWidth();

window.addEventListener('resize', setButtonWidth);

// Фон
if (gradient1) {
  let gradient = `linear-gradient(to right, ${gradient1}`;

  if (gradient2) {
    gradient += `, ${gradient2}`;
  }

  if (gradient3) {
    gradient += `, ${gradient3}`;
  }

  gradient += ')';

  a.style.setProperty('background', gradient, 'important');

} else if (buttonBackground) {

  a.style.setProperty(
    'background',
    buttonBackground,
    'important'
  );

} else {

  a.style.setProperty(
    'background',
    'linear-gradient(0.267turn, rgba(245, 82, 183, 1) 0%, rgba(128, 103, 248, 1) 49%, rgba(92, 208, 233, 1) 100%)'
  );
}

    // Колір тексту
    a.style.setProperty(
      'color',
      buttonColor || '#fff'
    );

    // Hover
    a.addEventListener('mouseenter', () => {
      a.style.setProperty(
        'color',
        buttonColor || '#fff'
      );

      a.querySelectorAll('*').forEach(child => {
        child.style.setProperty(
          'color',
          buttonColor || '#fff'
        );
      });
    });

    a.addEventListener('mouseleave', () => {
      a.style.setProperty(
        'color',
        buttonColor || '#fff'
      );

      a.querySelectorAll('*').forEach(child => {
        child.style.setProperty(
          'color',
          buttonColor || '#fff'
        );
      });
    });

    // ==========================================
    // ZOHO POPUP
    // ==========================================
    if (popupLink) {
  a.dataset.popupLink = popupLink;
  a.classList.add('popup-button');
}

  }
});

// last heading in blog
document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.rich-content-block[id]');
  const lastBlock = blocks[blocks.length - 1];

  if (!lastBlock) return;

  const heading = lastBlock.querySelector('.rich-content-heading');
  const text = lastBlock.querySelector('.rich-content-text');

  if (heading) {
    heading.classList.add('is-last-heading');
  }

  if (text) {
    text.classList.add('is-last-text');
  }
});

window.addEventListener('load', () => {
  document.querySelectorAll('.animate').forEach(el => {
    const rect = el.getBoundingClientRect()
    if (rect.top < window.innerHeight) {
      el.classList.add('visible')
    }
  })
})

/* if height of heading in product card is more than 30px make font size 15px */
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 749) {
    document.querySelectorAll('.product-card__content b p').forEach(el => {
      if (el.offsetHeight > 30) {
        el.style.fontSize = '15px';
        el.style.minHeight = '28px';
      }
    });
  } else {
    document.querySelectorAll('.product-card__content b p').forEach(el => {
      if (el.offsetHeight > 70) {
        el.style.fontSize = '9px';
      } else if (el.offsetHeight > 38) {
        el.style.fontSize = '12px';
      }
      
    });
  }
});

/* if height of subheading in product card is more than 40px make font size 12px */
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 749) {
    document.querySelectorAll('.product-card .text-block.custom p').forEach(el => {
      if (el.offsetHeight > 40) {
        el.style.fontSize = '12px';
      }
    });
  }
});


/* show footer form only on product and collection pages */
document.addEventListener('DOMContentLoaded', function () {
  const pageType = document.body.dataset.pageType;

  const allowedPages = ['product', 'collection'];

  if (!allowedPages.includes(pageType)) {
    const section = document.getElementById(
      'shopify-section-sections--31970194260305__section_b4Q8AE'
    );

    if (section) {
      section.style.display = 'none';
    }
  }
});